import { Flex, IconButton } from "@chakra-ui/react";
import React from "react";
import { IoClose, IoMenu } from "react-icons/io5";
import { Link } from "react-router-dom";
import { SiHomeLogo } from "../../../images/icons/components/SiHomeLogo";
import { buildDashboardLink } from "../../../routers/routePaths";

export function MobileNavbarHeader({
  accountId,
  isOpen,
  onClick,
}: {
  accountId: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return (
    <Flex align="center" justify="space-between" w="full" px={2} py={1}>
      <NavbarHomeLink accountId={accountId} />
      {isOpen ?
        <IconButton
          size="lg"
          fontSize="3xl"
          aria-label="Close navigation menu"
          colorScheme="gray"
          variant="ghost"
          onClick={onClick}
          icon={<IoClose />}
        />
      : <IconButton
          size="lg"
          fontSize="3xl"
          aria-label="Open navigation menu"
          colorScheme="gray"
          variant="ghost"
          onClick={onClick}
          icon={<IoMenu />}
        />
      }
    </Flex>
  );
}

export function DesktopNavbarHeader({
  accountId,
  isCollapsed,
}: {
  accountId: string;
  isCollapsed: boolean;
}) {
  return (
    <Flex align="center" justify="center" w="full" py={1}>
      <NavbarHomeLink accountId={accountId} isCollapsed={isCollapsed} />
    </Flex>
  );
}
const LOGO_WIDTH = "7rem";
const COLLAPSED_LOGO_WIDTH = "2.7rem";

function NavbarHomeLink({
  accountId,
  isCollapsed = false,
}: {
  accountId: string;
  isCollapsed?: boolean;
}) {
  return (
    <Flex
      as={Link}
      to={buildDashboardLink({ accountId })}
      align="center"
      w={isCollapsed ? COLLAPSED_LOGO_WIDTH : "12rem"}
      h="2.25rem"
      overflow="hidden"
      transition="width 0.2s ease"
    >
      <SiHomeLogo
        color="white"
        w={LOGO_WIDTH}
        h="auto"
        display="block"
        flexShrink={0}
      />
    </Flex>
  );
}
